export default "__VITE_ASSET__y3e7Z0Cj__"